<script setup lang="ts">
import { Card } from "@/components/Ui";

interface Props {
  value: number;
  title?: string;
  bg: "orange" | "light" | "dark";
}

const props = defineProps<Props>();
</script>

<template>
  <Card :class="`${$style[`root`]} ${$style[`bg-${props.bg || 'light'}`]}`">

    <div :class="$style.value">
      <span>{{ props.value }}</span>
      <span>%</span>
    </div>
    <div v-if="props.title || $slots.title" :class="[$style.title, $style[`title-${$i18n.locale}`]]">
      {{ props.title }}
      <slot name="title" />
    </div>
  </Card>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[32px] relative flex flex-col gap-[74px] overflow-hidden;
  @apply md:flex-row md:items-center md:justify-center;
  @apply lg:flex-col lg:justify-start;
  @apply px-[30px] py-[60px];
  @apply md:px-[60px] md:py-8 lg:px-[30px] lg:pb-[60px] lg:pt-[100px];
  @apply min-h-[500px] xxs:min-h-[530px] md:min-h-[268px] lg:min-h-[530px];
}

.bg {
  &-light {
    @apply bg-neutral-100 text-neutral-800;
  }

  &-orange {
    @apply text-white;
    background: linear-gradient(154.6deg, #F7D15F 0%, #FF7D00 100%);
  }

  &-dark {
    @apply bg-neutral-900 text-white;
  }
}

.value {
  @apply mt-auto md:mt-0 lg:mb-auto flex items-start justify-center leading-none;
  @apply md:w-[320px] md:justify-start;
  @apply lg:w-fit lg:justify-center;
  & span {
    @apply font-bold;
    &:first-of-type {
      @apply ltr:order-1 rtl:order-2 text-[212px] xxs:text-[208px] xs:text-[216px] lg:text-[202px] xl:text-[216px];
      letter-spacing: -10px;
    }

    &:last-child {
      @apply ltr:order-2 rtl:order-1 text-[40px] xxs:text-[42px] xs:text-[46px] ltr:-ml-4 rtl:-ml-4 mt-2;
    }
  }
}

.title {
  @apply ltr:lg:mr-auto rtl:lg:ml-auto font-black leading-none;
  @apply md:w-[320px] md:justify-start;
  @apply lg:w-fit lg:justify-center;
  @apply text-[36px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-bg,
  &-it,
  &-pt,
  &-tr,
  &-ua,
  &-zh,
  &-de,
  &-bg,
  &-ru,
  &-ja,
  &-es,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[36px];
  }
  &-zh {
    @apply leading-[1.2];
  }
  &-ja {
    @apply leading-[1.2];
  }
  &-fr {
    @apply text-[32px] xs:text-[36px];
  }
}
</style>